import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';
import {
  CustomerEnrollmentBillingResponseItem,
  CustomerEnrollmentBillingTableData,
  CustomerEnrollmentBillingTableRowActions
} from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: CustomerEnrollmentBillingResponseItem[],
  actions: CustomerEnrollmentBillingTableRowActions
): CustomerEnrollmentBillingTableData[] =>
  data.map((CustomerEnrollmentBillingItem: CustomerEnrollmentBillingResponseItem) => {
    const { cost, id, ...rest } = CustomerEnrollmentBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
